import { useModals } from 'almanac-ui/Modal'
import { AutopilotFreemiumUpgradeModal } from 'components/AutopilotFreemiumUpgradeModal/AutopilotFreemiumUpgradeModal'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { observer } from 'mobx-react-lite'
import { useEffect, useRef } from 'react'

export const FreemiumStartedListener = observer(() => {
  const workspace = useCurrentWorkspace()
  const { openModal } = useModals()
  const hasShownModal = useRef(false)

  useEffect(() => {
    if (!hasShownModal.current && workspace?.is_ap_freemium && workspace?.is_ap_freemium_brand_plan_set === false) {
      openModal(AutopilotFreemiumUpgradeModal)
      hasShownModal.current = true
    }
  }, [workspace?.is_ap_freemium, workspace?.is_ap_freemium_brand_plan_set, openModal])

  return null // This component doesn't render anything
})
